import React from "react";
import DatePicker from './DatePicker'
import FixButton from './Button'
import Cookies from 'universal-cookie';
import moment from 'moment';
import getLezioni from "../services/getLezioni";
import getInsegnanti from "../services/getInsegnanti";
import generateExcel from "../services/generateExcel";
import Constants from "../utils/consts";

export default class SelectExcelPeriodWidget extends React.Component {

    constructor (props){
        super(props);

        this.dateRef = React.createRef();
        this.toRef = React.createRef();

    }

    async componentDidMount(){
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        this.lezioni = await getLezioni(username, token);
        this.insegnanti = await getInsegnanti(username, token);
        this.setState({
            visible: this.props.show,
        });

    }

    render (){

        if (!this.state) return <div />;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass);

        return ( 
            <>
                <div key={Math.random()} style={st} >
                    <div style={closeIcon} onClick={() => {
                        this.setState({visible: false});
                        this.props.onCancel();
                    }}>X</div>
                    <div style={{marginTop: '10px'}}>
                        <div className="windowTitle">
                            Seleziona la data
                        </div>
                        <DatePicker ref={this.dateRef} name="Dal: " />
                        <DatePicker ref={this.toRef} name="Al: " />
                        <FixButton title={'OK'} callback={this.okClicked.bind(this)} />
                    </div>
                </div>
            </>
        )
    }

    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async okClicked(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        const date = this.dateRef.current.getDate();
        const toDate = this.toRef.current.getDate();

        let dal = moment(date).format('yyyy-MM-DD');
        let al = moment(toDate).format('yyyy-MM-DD');

        let dalDate = moment(dal, 'yyyy-MM-DD');
        let alDate = moment(al, 'yyyy-MM-DD');

        if (dal == "Invalid date" || al == "Invalid date") {
            alert("Scegli una data valida.")
            return
        }

        let lezioni = this.lezioni.filter((lezione) => {
            
            let dataLezione = moment(lezione.data.substring(0, 10), "yyyy-MM-DD");
            return dataLezione.isSameOrAfter(dalDate) && dataLezione.isSameOrBefore(alDate);
        });

        if (lezioni.length === 0) {
            alert('Nessuna lezione trovata')
            return
        }

        let insegnantiShowRestart = this.insegnanti.filter(insegnante => {
            return insegnante.regime === 'FAT_1';
        });

        var giorni = [];
        let header = [];
        header.push("Lezioni insegnanti dal: " + dal + " al: " + al);
        header.push("CF");

        var data = dalDate
        while (data.isSameOrBefore(alDate)) {
            giorni.push(data.format('yyyy-MM-DD'));
            header.push(data.format('DD'));
            data = data.add(1, 'day');
        }

        header.push('ORE TOT.');
        header.push('GIORNI TOT.');

        var oreTot = 0.0;
        var giorniTot = 0;

        let datiInsegnanti = [];
        insegnantiShowRestart.forEach(ins => {
            var temp = [];

            temp.push(ins.cognome + ' ' + ins.nome);
            temp.push(ins.codiceFiscale);
            var totaleOre = 0.0
            var totaleGiornate = 0
            
            giorni.forEach(g => {

                var ore = 0.0;
                var giornate = 0;
                let lez = lezioni;
                let lezioniGiorno = lez.filter(l => l.data.includes(g) && (l.id_insegnante === ins.id || l.altri_insegnanti.indexOf(ins.id + ';') !== -1));
                lezioniGiorno.forEach(l => {
                    if (l.fattura_giornaliera === '1') {
                        giornate++;
                        totaleGiornate++;
                    } else {
                        ore += l.durata/60.0;
                        totaleOre += l.durata/60.0;
                    }
                });
                
                let time = ore.toFixed(2) + "H - " + giornate + 'G';
                temp.push(time !== '0.00H - 0G' ? time : '');
            });

            temp.push(totaleOre + ' H');
            temp.push(totaleGiornate + ' G');

            oreTot += totaleOre;
            giorniTot += totaleGiornate;

            datiInsegnanti.push(temp);
        });
        
        var jsonData = [header];

        datiInsegnanti.forEach(insegnante => {
        jsonData.push(insegnante);
        });

        var jsonTabs = [];
        jsonTabs.push({
        name: 'SR_' + dal.replace(/-/g,'') + '_' + al.replace(/-/g, ''),
        data: jsonData
        });

        var json = {
            tabs : jsonTabs
        };

        console.log("JSON", json);

        await generateExcel(username, token, JSON.stringify(json), 'SR_' + dal.replace(/-/g,'') + '_' + al.replace(/-/g, ''));
        window.open('https://' + Constants.mainUrl + 'pdf/' + 'SR_' + dal.replace(/-/g,'') + '_' + al.replace(/-/g, '') + '.xlsx', '_blank');

        this.props.onOkClicked(dal);
    }
}


const menu = {
    position: 'relative',
    top: '10px',
    display: 'flex',
};

const menuVoice = {
    width: '50%',
    textAlign: 'center',
    border: '1px solid black',
    cursor: 'pointer'
}

const title = {
    top: '10xp',
    width: '100%',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center',
};

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 0, 
    top: 0, 
    padding: 10
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    zIndex: 999
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}